import Paginacao from "../types/paginacao";
import WarehouseUserClientReportDaily from "../types/warehouseUserClientReportDaily";
import api, { fetchData } from "./api";

export interface WarehouseUserClientReportDailyVM {
    version: number;
    clientId: string;
    wrId: string;
    userId: string;
}

export interface WarehouseUserClientReportDailyPutVM {
    id: number;
    clientId: number | null;
    wrId: number | null;
    userId: number | null,
}

export interface WarehouseUserClientReportDailyResponse {
    id: number;
    version: number;
    clientId: number;
    clientName: string,
    wrId: number;
    wrName: string,
    userId: number;
    userName: string
}

export interface Company {
    id: number;
    name: string;
}

export interface User {
    id: number;
    username: string;
}

export interface WarehouseUserClientReportDailyResponse2 {
    id: number;
    version: number;
    client: Company | null;
    wr: Company | null;
    users: User[] | null;
}

export interface WarehouseUserClientReportDailyApiResponse {
    data: WarehouseUserClientReportDailyResponse[];
    messages: any; 
}

export interface WarehouseUserClientReportDailyApiCreateResponse {
    data: WarehouseUserClientReportDailyResponse;
    messages: any; 
}

export const getListaWarehouseUserClientReportDaily = async () => {
    try {
        const endpoint: string = "/WarehouseUserClientReportDaily/all";
        const response = await fetchData<WarehouseUserClientReportDailyResponse>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de warehouseUserClientReportDaily:", error);
        throw error;
    }
}; 

export const getListaWarehouseUserClientReportDailyPaginated = async (paginacao: Paginacao) => {
    try {
        const endpoint: string = "/WarehouseUserClientReportDaily/all/paginado";
        const params: Record<string, any> = {
            pageNum: paginacao.pageNum + 1,
            quantityPerPage: paginacao.quantityPerPage,
        };
        const response = await fetchData<WarehouseUserClientReportDaily>(endpoint, params);
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de warehouseUserClientReportDaily:", error);
        throw error;
    }
}; 

export const getWarehouseUserClientReportDailyById = async (id: number) => {
    try {
        const response = await api.get<WarehouseUserClientReportDailyApiResponse>(`/WarehouseUserClientReportDaily/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar warehouseUserClientReportDaily com ID ${id}`, error);
        throw error;
    }
};

export const createWarehouseUserClientReportDaily = async (warehouseUserClientReportDaily: WarehouseUserClientReportDailyVM) => {
    try {
        const response = await api.post<WarehouseUserClientReportDailyApiCreateResponse>("/WarehouseUserClientReportDaily", warehouseUserClientReportDaily);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar warehouseUserClientReportDaily:", error);
        throw error;
    }
};

export const updateWarehouseUserClientReportDaily = async (id: number, warehouseUserClientReportDaily: WarehouseUserClientReportDailyPutVM) => {
    try {
        const response = await api.put<WarehouseUserClientReportDailyApiResponse>(`/WarehouseUserClientReportDaily/${id}`, warehouseUserClientReportDaily);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar warehouseUserClientReportDaily com ID ${id}:`, error);
        throw error;
    }
};

export const deleteWarehouseUserClientReportDaily = async (id: number) => {
    try {
        await api.delete(`/WarehouseUserClientReportDaily/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir warehouseUserClientReportDaily com ID ${id}:`, error);
        throw error;
    }
};

export const sendDailyReportEmail = async (clients: number[], input?: Date) => {
    try {
        const response = await api.post("/WarehouseUserClientReportDaily/sendreport", {
            clients,
            input
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao enviar email de relatório diário:", error);
        throw error;
    }
};
